/* ═══ OS FAVORITOS — [2026-08-22] ═══════════════════════════════════════════
   🔑 A LISTA MORA NO NAVEGADOR, sem conta. Pedir cadastro para guardar um
     favorito é pedir compromisso antes de entregar valor — e quem favorita está
     decidindo, não comprando. O preço é a lista não atravessar dispositivos, e
     é um preço justo para o ganho de não ter barreira nenhuma.

   🪤 `localStorage` PODE LANÇAR EXCEÇÃO, e não é caso raro: no Safari em janela
     privada ele existe, responde a `typeof`, e ESTOURA na escrita. Sem o
     try/catch, o clique no coração derrubaria o script inteiro da página — e
     com ele o quickview, que vive no mesmo cartão.

   🪤 O ESTADO É PINTADO DEPOIS. O HTML nasce sempre "não favoritado" porque a
     página é servida em cache pela CDN: marcar no Liquid mostraria a lista de
     quem gerou o cache, não a de quem está lendo.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var CHAVE = 'ettore:favoritos';

  function ler() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); }
    catch (e) { return []; }
  }
  function gravar(lista) {
    try { localStorage.setItem(CHAVE, JSON.stringify(lista)); } catch (e) { /* janela privada */ }
    /* quem estiver ouvindo (a página de favoritos, o contador) se atualiza */
    document.dispatchEvent(new CustomEvent('ettore:favoritos', { detail: lista }));
  }

  function pinta(bt, ativo) {
    bt.classList.toggle('is-fav', ativo);
    bt.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    var nome = bt.getAttribute('aria-label') || '';
    if (ativo) bt.setAttribute('aria-label', nome.replace(/^Guardar/, 'Tirar dos favoritos:'));
    else bt.setAttribute('aria-label', nome.replace(/^Tirar dos favoritos:/, 'Guardar'));
  }

  function sincroniza() {
    var lista = ler();
    document.querySelectorAll('[data-fav]').forEach(function (bt) {
      pinta(bt, lista.indexOf(bt.getAttribute('data-fav')) !== -1);
    });
    document.querySelectorAll('[data-fav-contador]').forEach(function (el) {
      el.textContent = lista.length;
      el.hidden = lista.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var bt = e.target.closest('[data-fav]');
    if (!bt) return;
    e.preventDefault();
    /* 🪤 e o stopPropagation também: o cartão inteiro é um link (`.pc-cobre`),
       e sem isto favoritar levaria a pessoa para a página do produto. */
    e.stopPropagation();
    var h = bt.getAttribute('data-fav');
    var lista = ler();
    var i = lista.indexOf(h);
    if (i === -1) lista.push(h); else lista.splice(i, 1);
    gravar(lista);
    sincroniza();
  });

  document.addEventListener('ettore:favoritos', sincroniza);
  /* outra aba mexeu na lista */
  window.addEventListener('storage', function (e) { if (e.key === CHAVE) sincroniza(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincroniza);
  else sincroniza();
})();
